var app = app || {};
(function ($) {
    app.ChangeTracker = (function () {
        function TrackItem(id, element, originalValue, hasChanged) {
            this.id = id;
            this.element = element;
            this.originalValue = originalValue;
            this.hasChanged = hasChanged;
        }

        let _internalInit = function (changeTracker, container) {
            $('input:not(.ignore-track-change):not([readonly]):not([disabled]):not([type="hidden"]:not(.track-change)):not([id$="-selectized"]):not([type="text"][inputmode="decimal"]), textarea:not(.ignore-track-change):not([readonly]):not([disabled]), select:not(.ignore-track-change):not([readonly]):not([disabled])', $(container)).not(".ignore-track-change *").each(function () {
                const element = this;
                const $element = $(this);
                let key = $element.attr("id");
                if (!key) {
                    key = Date.now() + Math.random();
                }

                let type = $element.attr("type");
                if (type) {
                    type = type.toLowerCase();
                }

                let originalValue;
                let hasChanged;

                switch (type) {
                    case "checkbox":
                    case "radio":
                        originalValue = $element.is(":checked");
                        hasChanged = function (element, originalValue) {
                            let ov;
                            if (typeof (originalValue) === "function") {
                                ov = originalValue(element);
                            } else {
                                ov = originalValue;
                            }

                            return ov !== $(element).is(":checked");
                        };
                        break;

                    default:
                        originalValue = $element.val();
                        hasChanged = function (element, originalValue) {
                            let ov;
                            if (typeof (originalValue) === "function") {
                                ov = originalValue(element);
                            } else {
                                ov = originalValue;
                            }

                            if (Array.isArray(originalValue)) { // array indicates the element is select.multiple
                                if (!Array.isArray($(element).val())) {
                                    return true;
                                }

                                let hasChanged = false;
                                $.each($(element).val(),
                                    function (index, value) {
                                        if (originalValue[index] !== value) {
                                            hasChanged = true;

                                            return false;
                                        }
                                    });

                                return hasChanged;
                            }

                            return ov !== $(element).val();
                        };
                        break;
                }

                changeTracker.add(key, element, originalValue, hasChanged);
            });
        };

        return function () {
            let runningId = 0;
            let list = {};

            this.init = function (container) {
                runningId = 0;
                list = {};

                _internalInit(this, container);
            };
            this.add = function (key, element, originalValue, hasChanged) {
                if (!key) {
                    key = `changeTracker_${++runningId}`;
                }
                list[key] = new TrackItem(key, element, originalValue, hasChanged);
            };
            this.remove = function (key) {
                delete list[key];
            };
            this.clear = function (key) {
                runningId = 0;
                list = {};
            };
            this.hasChanges = function () {
                let hasChanges = false;

                $.each(list, function (key, trackItem) {
                    if (trackItem.hasChanged(trackItem.element, trackItem.originalValue)) {
                        hasChanges = true;
                        return false;
                    }
                });
                
                return hasChanges;
            };
            this.hasChanged = function (key) {
                const trackItem = list[key];
                if (!trackItem) {
                    return null;
                }

                return trackItem.hasChanged(trackItem.element, trackItem.originalValue);
            };
            this.getInit = function () {
                return _internalInit;
            };
            this.setInit = function (initCallback) {
                _internalInit = initCallback;
            };
            this.getResult = function (showOnlyItemsWithChanges = false) {
                let hasChanges = false;
                const items = [];

                $.each(list, function (key, trackItem) {
                    let hasChanged = false;
                    if (trackItem.hasChanged(trackItem.element, trackItem.originalValue)) {
                        hasChanged = true;
                        hasChanges = true;
                    }

                    if (!showOnlyItemsWithChanges || (showOnlyItemsWithChanges && hasChanged)) {
                        items.push({
                            id: trackItem.id,
                            element: trackItem.element,
                            originalValue: trackItem.originalValue,
                            hasChanged: hasChanged
                        });
                    }
                });

                return {
                    hasChanges: hasChanges,
                    trackItems: items
                };
            };
        };
    }());
})(jQuery);
